import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface MarkProps {
    children: ReactNode
    tone?: 'light' | 'dark'
    className?: string
}

/*
 * Coral highlight for headline words. On dark backgrounds the text itself turns coral.
 * On light backgrounds coral text is too faint to read, so the word sits on a coral block instead.
 */
export const Mark: FC<MarkProps> = ({ children, tone = 'light', className }): ReactNode => {
    if (tone === 'dark') return <span className={cn('text-coral', className)}>{children}</span>

    return (
        <span className={cn('bg-coral px-[0.06em] text-charcoal [box-decoration-break:clone] [-webkit-box-decoration-break:clone]', className)}>
            {children}
        </span>
    )
}

interface OutlineProps {
    children: ReactNode
    tone?: 'light' | 'dark'
    className?: string
}

/* Outlined headline word. Falls back to solid text in browsers without text stroke support. */
export const Outline: FC<OutlineProps> = ({ children, tone = 'light', className }): ReactNode => {
    return (
        <span className={cn(tone === 'dark' ? 'text-outline-cream' : 'text-outline-charcoal', className)}>
            {children}
        </span>
    )
}
